import React from 'react';
import PropTypes from 'prop-types';
import { publicPath } from '../../config/env';

export default function AdminPreAuthLayout({ children, maxWidth = 400 }) {
  const logoUrl = publicPath('/images/defti_logo.svg');

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-body">
      <div className="w-100" style={{ maxWidth }}>
        <div className="d-flex justify-content-center align-items-center mb-4">
          <img
            src={logoUrl}
            alt="Defti Logo"
            style={{ maxWidth: '100%', height: '3rem', objectFit: 'contain' }}
            className="mb-2 mt-1"
          />
        </div>
        {children}
      </div>
    </div>
  );
}

AdminPreAuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
  maxWidth: PropTypes.number,
};
